// extracted by mini-css-extract-plugin
export default {"messageGroupRight":"MessageGroupRight_messageGroupRight__WON-w","messageListRight":"MessageGroupRight_messageListRight__EnJCH"};